import { Settings as LayoutSettings } from '@ant-design/pro-components';

const Settings: LayoutSettings & {
  pwa?: boolean;
  logo?: string;
  headerTheme?: string;
  primaryColor?: string;
} = {
  navTheme: 'light',
  headerTheme: 'light',
  // 拂晓蓝
  primaryColor: '#FF8417',
  layout: 'side',
  contentWidth: 'Fluid',
  fixedHeader: true,
  fixSiderbar: true,
  title: 'LightCDN',
  splitMenus: false,
  pwa: false,
  logo: '/logo.png',
  iconfontUrl: '',
};

export default Settings;
